module.exports = __webpack_public_path__ + "img/skeleton.fb4656e4.png";